import { getAspectRatioStyle } from "@common/controls/AspectRatioContainer/lib";
import Script from "@common/controls/Html/Script";
import classnames from "classnames";
import * as React from "react";
import { type VideoProps } from "../component";
import { getKey, getOptions, getVideoId } from "./lib";

export type WistiaVideoProps = VideoProps & {
  videoId?: string;
};

/* applying style={getAspectRatioStyle(props.aspectRatio) to the wrapper adds to height */
const WistiaVideo = (props: WistiaVideoProps) => (
  <div
    className={classnames("video_container", { background: props.isBackground })}
    style={getAspectRatioStyle(props.aspectRatio)}
  >
    <div key={getKey(props)} className="video wistia_video">
      <div className={`wistia_embed video wistia_async_${getVideoId(props)} ${getOptions(props)}`} />

      <Script src="https://fast.wistia.net/assets/external/E-v1.js" isAsync />

      {props.isBackground && <div className="overlay" />}
    </div>
  </div>
);

export default WistiaVideo;
